import React from 'react';
import { Controller, Control } from 'react-hook-form';

import RichTextComponent from './RichTextComponent';

interface RichTextControlledInputProps {
  name: string;
  control: Control<any>;
  disabled?: boolean;
}

const RichTextControlledInput: React.FC<RichTextControlledInputProps> = ({
  name,
  control,
  disabled,
}) => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }) => (
      <RichTextComponent
        disabled={disabled}
        value={value}
        init={{
          height: 500,
          menubar: true,
          plugins: [
            'anchor',
            'autolink',
            'charmap',
            'code',
            'help',
            'image',
            'insertdatetime',
            'link',
            'lists',
            'searchreplace',
            'table',
            'visualblocks',
          ],
          toolbar:
            'undo redo | image link pageembed  | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist checklist outdent indent | removeformat | table help',
        }}
        onEditorChange={onChange}
      />
    )}
  />
);

export default RichTextControlledInput;
